import React from "react";
import { useNavigate } from "react-router-dom";
import TableAbouts from "./components/TableAbouts";
import { MdAdd } from "react-icons/md";

function Abouts() {
  const navigate = useNavigate();

  return (
    <div className="mt-5 px-2">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-navy-700 dark:text-white">Manajemen Tentang</h2>
          <p className="text-sm text-gray-500 mt-1">Kelola informasi tentang organisasi</p>
        </div>
        <button
          onClick={() => navigate("/admin/add-abouts")}
          className="flex items-center gap-2 rounded-xl px-5 py-3 text-sm font-bold text-white shadow-sm transition-colors"
          style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}
        >
          <MdAdd className="h-5 w-5" />
          Tambah About
        </button>
      </div>
      <div className="rounded-2xl bg-white shadow-sm overflow-hidden dark:bg-navy-700">
        <TableAbouts />
      </div>
    </div>
  );
}

export default Abouts;
